<template>
    <!-- TESTIMONIALS-1
			============================================= -->
			<section id="reviews-1" class="bg-whitesmoke-gradient wide-100 reviews-section division">
                <div id="testimonial"></div>
				<div class="container">


					<!-- SECTION TITLE -->
					<div class="row justify-content-center">
						<div class="col-lg-10 col-xl-8">
							<div class="section-title title-01 mb-70">

								<!-- Title -->
								<h2 class="h2-md">Reviews From Our Customers</h2>

								<!-- Text -->
								<p class="p-xl">See what our customers think about Creditfixrr.com.
								</p>

							</div>
						</div>
					</div>


					<!-- TESTIMONIALS CONTENT -->
					<div class="row">
						<div class="col">
							<div class="owl-carousel owl-theme reviews-1-wrapper">


								<!-- TESTIMONIAL #1 -->
								<div class="review-1">

									<!-- Quote Icon -->
		 							<div class="review-1-ico ico-25">
										<span class="flaticon-left-quote"></span>
									</div>

									<!-- Text -->
									<div class="review-1-txt">

										<!-- Text -->
										<p class="p-lg">
                                            I'm extremely grateful to have found Creditfixrr.com.
                                            Trying to learn how to fix your own credit can be really overwhelming.
                                            Creditfixrr.com is user friendly and I felt like I was done with my dispute after a few clicks.
                                            The best part was actually seeing results. Getting those negative items removed actually had
                                            a positive change on my life. I was finally able to get a new car.
										</p>

										<!-- Testimonial Author -->
										<div class="author-data clearfix">

											<!-- Testimonial Avatar -->
											<!-- <div class="review-avatar">
												<img src="/landing/images/review-author-1.jpg" alt="review-avatar">
											</div> -->

											<!-- Testimonial Author -->
											<div class="review-author">

												<h6 class="h6-xl">Keliah L</h6>
												<!-- <p class="p-md">@scott_boxer</p> -->

												<!-- Rating -->
												<div class="review-rating ico-15 yellow-color">
													<span class="flaticon-star-1"></span>
													<span class="flaticon-star-1"></span>
													<span class="flaticon-star-1"></span>
													<span class="flaticon-star-1"></span>
													<span class="flaticon-star-half-empty"></span>
												</div>

											</div>

										</div>	<!-- End Testimonial Author -->

									</div>	<!-- End Text -->

								</div>	<!-- END TESTIMONIAL #1 -->


								<!-- TESTIMONIAL #2 -->
								<div class="review-1">

									<!-- Quote Icon -->
		 							<div class="review-1-ico ico-25">
										<span class="flaticon-left-quote"></span>
									</div>

									<!-- Text -->
									<div class="review-1-txt">

										<!-- Text -->
										<p class="p-lg">
                                            ATT: All other credit repair services can kick rocks!
                                            I wish I had known about Creditfixrr.com long ago! This is the best DIY credit
                                            software in the market and the most easiest to follow and understand. I highly
                                            recommend it to everyone young and old. The software includes video tutorials for
                                            the slower paced audience and all the important documents needed, step by step.
                                            It makes life simple! What are you waiting for? Get your credit fixed today with Creditfixrr.com!
										</p>

										<!-- Testimonial Author -->
										<div class="author-data clearfix">

											<!-- Testimonial Avatar -->
											<!-- <div class="review-avatar">
												<img src="/landing/images/review-author-8.jpg" alt="review-avatar">
											</div> -->

											<!-- Testimonial Author -->
											<div class="review-author">

												<h6 class="h6-xl">Mari A</h6>
												<!-- <p class="p-md">Internet Surfer</p> -->

												<!-- Rating -->
												<div class="review-rating ico-15 yellow-color">
													<span class="flaticon-star-1"></span>
													<span class="flaticon-star-1"></span>
													<span class="flaticon-star-1"></span>
													<span class="flaticon-star-1"></span>
													<span class="flaticon-star-half-empty"></span>
												</div>

											</div>

										</div>	<!-- End Testimonial Author -->

									</div>	<!-- End Text -->

								</div>	<!-- END TESTIMONIAL #2 -->


								<!-- TESTIMONIAL #3 -->
								<div class="review-1">

									<!-- Quote Icon -->
		 							<div class="review-1-ico ico-25">
										<span class="flaticon-left-quote"></span>
									</div>

									<!-- Text -->
									<div class="review-1-txt">

										<!-- Text -->
										<p class="p-lg">
                                            After doing my research on multiple different credit repair agencies and businesses; Creditfixrr.com is my go- to!
                                            Khabir, (the founder of Creditfixrr.com), FREELY shared his time to walk me through the process and explain in detail
                                            how the program works. In today's society, it's very hard to find someone like Khabir who's so passionate about
                                            Creditfixrr.com and donated his time and energy to answer all my questions. Creditfixrr.com is by far the best program out
                                            there and I highly recommend that you check it out for yourself. Include your family members and colleagues, too!
                                            You'll thank me later
										</p>

										<!-- Testimonial Author -->
										<div class="author-data clearfix">

											<!-- Testimonial Avatar -->
											<!-- <div class="review-avatar">
												<img src="/landing/images/review-author-3.jpg" alt="review-avatar">
											</div> -->

											<!-- Testimonial Author -->
											<div class="review-author">

												<h6 class="h6-xl">Sea and Sun Initiatives</h6>
												<!-- <p class="p-md">@marisol19</p> -->

												<!-- Rating -->
												<div class="review-rating ico-15 yellow-color">
													<span class="flaticon-star-1"></span>
													<span class="flaticon-star-1"></span>
													<span class="flaticon-star-1"></span>
													<span class="flaticon-star-1"></span>
													<span class="flaticon-star-half-empty"></span>
												</div>

											</div>

										</div>	<!-- End Testimonial Author -->

									</div>	<!-- End Text -->

								</div>	<!-- END TESTIMONIAL #3 -->


								<!-- TESTIMONIAL #4 -->
								<div class="review-1">

									<!-- Quote Icon -->
		 							<div class="review-1-ico ico-25">
										<span class="flaticon-left-quote"></span>
									</div>

									<!-- Text -->
									<div class="review-1-txt">

										<!-- Text -->
										<p class="p-lg">
                                            This is the best DIY software ever I think it's the first of its kind!
                                            Forget those other services that "promises" certain things off your
                                            credit this is doing minimal work with the best results!
										</p>

										<!-- Testimonial Author -->
										<div class="author-data clearfix">

											<!-- Testimonial Avatar -->
											<!-- <div class="review-avatar">
												<img src="/landing/images/review-author-4.jpg" alt="review-avatar">
											</div> -->

											<!-- Testimonial Author -->
											<div class="review-author">

												<h6 class="h6-xl">Kamkilledit LLC.</h6>
												<!-- <p class="p-md">Web Developer</p> -->

												<!-- Rating -->
												<div class="review-rating ico-15 yellow-color">
													<span class="flaticon-star-1"></span>
													<span class="flaticon-star-1"></span>
													<span class="flaticon-star-1"></span>
													<span class="flaticon-star-1"></span>
													<span class="flaticon-star-half-empty"></span>
												</div>

											</div>

										</div>	<!-- End Testimonial Author -->

									</div>	<!-- End Text -->

								</div>	<!-- END TESTIMONIAL #4 -->


							</div>
						</div>
					</div>	<!-- END TESTIMONIALS CONTENT -->


				</div>     <!-- End container -->
			</section>	<!-- END TESTIMONIALS-1 -->
</template>
